import { render, staticRenderFns } from "./CommentCell.vue?vue&type=template&id=ed36934c&"
import script from "./CommentCell.vue?vue&type=script&lang=js&"
export * from "./CommentCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports